// Versão do app - gerado automaticamente
export const APP_VERSION = '5.42'
export const BUILD_DATE = '18/05/2026, 03:55'
